import { render, staticRenderFns } from "./askdetail.vue?vue&type=template&id=501b5993&scoped=true&"
import script from "./askdetail.vue?vue&type=script&lang=js&"
export * from "./askdetail.vue?vue&type=script&lang=js&"
import style0 from "./askdetail.vue?vue&type=style&index=0&id=501b5993&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b5993",
  null
  
)

export default component.exports